import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useSelector } from '@grandvisionhq/state';
import { ConfigurationTotalPrice } from '../../../../../../Configurator/components/ConfigurationTotalPrice/ConfigurationTotalPrice.js';
import { useRxGlassesConfiguratorContext } from '../../../Context/RxGlassesConfiguratorContext.js';
import { getBundlePrice } from '../../../../state/configurator/selectors.js';

const ConfigurationTotalPriceContainer = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const isPhone = MediaQuery.useIsPhone();
    const bundlePrice = useSelector((s)=>getBundlePrice(s, {
            id
        })
    );
    if (!bundlePrice || !bundlePrice.originalPrice) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ConfigurationTotalPrice, swcHelpers.extends({
        centAmount: true,
        size: isPhone ? 'medium' : 'large'
    }, bundlePrice));
};

export { ConfigurationTotalPriceContainer };
//# sourceMappingURL=ConfigurationTotalPriceContainer.js.map
